import type { Static } from "runtypes";
import { Record } from "runtypes";
import { BillingPlan } from "./BillingPlan";

export const BillingPlanResponse = Record({
  plan: BillingPlan,
});

export type BillingPlanResponseType = Static<typeof BillingPlanResponse>;
